<template>
  <div class="chat-container">
    <div class="mt-8 header px-4 py-3 bg-white border-bottom">
      <div class="d-flex align-center">
        <div class="font-weight-bold flex-fill d-flex">
          <small>Chat de la transmisión</small>
        </div>
        <div>
          <button
            type="button"
            class="ml-2"
            @click="$emit('hideChat')"
          >
            <Icon
              :width="24"
              :color="'rgba(0,0,0,.54)'"
              :icon="'close'"
            />
          </button>
        </div>
      </div>
    </div>
    <Messages @messagetoRespond="messagetoRespond" />
    <div>
      <div
        class="reply-head"
        v-if="show"
      >
        <div class="d-flex justify-space-between">
          <p class="my-0">
            <small>Respondiendo a {{parent ? parent.author_name : ''}}</small>
          </p>
          <button @click="closeResponse">
            <Icon
              :width="15"
              :color="'rgba(0,0,0,.54)'"
              :icon="'close'"
              class="" />
          </button>
        </div>
        <p class="reply-message">- {{parent ? parent.message : ''}}</p>
      </div>
      <div v-if="$store.state.widget.uuid">
        <v-slide-y-transition>
          <TextField
            @sendMessage="sendMessage"
            :disabled="false"
            v-if="customer"
          />
          <div v-else class="px-2 py-1">
            <v-btn
              block
              elevation="0"
              rounded
              @click="setCustomer"
            >
              Enviar un mensaje
            </v-btn>
          </div>
        </v-slide-y-transition>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Messages: () => import(/* webpackPrefetch: true */ '@/views/room/components/chat/components/Messages.vue'),
    TextField: () => import(/* webpackPrefetch: true */ '@/views/room/components/chat/components/TextField.vue'),
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  props: {
    room: {
      type: Object,
      default: null
    },
    customer: {
      type: Object,
      default: null
    }
  },
  data(){
    return {
      show: false,
      parent: null
    }
  }
})
export default class Index extends Vue {
  sendMessage (message) {
    if (!this.customer) {
      return false
    }

    const data = {
      author: this.customer,
      session: this.room._id,
      message,
      level: 1,
      uuid: this.$store.state.widget.uuid,
    }

    if (this.parent) {
      data.parent = this.parent
    }

    this.closeResponse()
  }

  setCustomer () {
    this.$emit('setCustomer')
  }

  messagetoRespond (parentMessage) {
    document.getElementById('messageInput').focus()
    this.parent = {
      message_id: parentMessage._id,
      author_name: parentMessage.author.name,
      message: parentMessage.message
    }
    this.show = true
  }

  closeResponse () {
    this.show = false
    this.parent = null
  }
}
</script>

<style>
  .chat-container{
    height: 100%;
    display: flex;
    flex-flow: column;
  }
  .header{
    border-bottom: 1px solid rgb(230, 230, 230);
  }
  .reply-head{
    width: 100%;
    background: #fff;
    padding: 10px 20px 5px;
    color: rgb(129, 129, 129);
    border-top: 1px solid rgb(238, 238, 238);
    border-bottom: 1px solid rgb(238, 238, 238);
  }
  .reply-message{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis "...";
    font-size: 12px;
    height: 25px;
    margin: 0 !important;

  }
</style>
